import React from 'react';
import { useTranslation } from 'react-i18next';

import { LabeledSelect } from '../Input/LabeledSelect';

const LagalStatus = ({ allowClear = true,
  disabled, ...props }) => {
  const [ t ] = useTranslation();

  return (
    <LabeledSelect
      placeholder={ t('fields.choose') }
      { ...props }
      disabled={ disabled }
      allowClear={ allowClear }
      options={ [
        { text: t('fields.lagalStatus.prescriptioned'), value: '1' },
        { text: t('fields.lagalStatus.nonPrescriptioned'), value: '0' }
      ] }
    />
  );
};
export default LagalStatus;
